var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":_vm.viewBox,"fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.5 18.7V13.7H8.20775V18.7H6.5ZM11.204 18.7V10.1H12.9115V18.7H11.204ZM15.7922 18.7V5.30005H17.5V18.7H15.7922Z","fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }